import React from 'react'
import './Widgetsmall.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
export default function Widgetsmall() {
    return (
        <div className = "WidgetSmall">
            <span className="widgetsmallTitle">New Join Memebers</span>
            <ul className="widgetSmallList">
                <li className="widgetsmalllistItem">
                <img src = "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=465&q=80" alt = "hello"  className = "widget-profile-image" />
                    <div className="widgetSmalleruser">
                        <span className="widgetsmallerUsername">Anna Keller</span>
                        <span className="widgetsmallerUserjob">Software Engineer</span>
                    </div>
                    <button className="widgetsmallbtn"><VisibilityIcon className = "widgetSmallicon" /> Display</button>
                </li>
            </ul>
            <ul className="widgetSmallList">
                <li className="widgetsmalllistItem">
                <img src = "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=465&q=80" alt = "hello"  className = "widget-profile-image" />
                    <div className="widgetSmalleruser">
                        <span className="widgetsmallerUsername">Anna Keller</span>
                        <span className="widgetsmallerUserjob">Software Engineer</span>
                    </div>
                    <button className="widgetsmallbtn"><VisibilityIcon className = "widgetSmallicon" /> Display</button>
                </li>
            </ul>
            <ul className="widgetSmallList">
                <li className="widgetsmalllistItem">
                <img src = "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=465&q=80" alt = "hello"  className = "widget-profile-image" />
                    <div className="widgetSmalleruser">
                        <span className="widgetsmallerUsername">Anna Keller</span>
                        <span className="widgetsmallerUserjob">Software Engineer</span>
                    </div>
                    <button className="widgetsmallbtn"><VisibilityIcon className = "widgetSmallicon" /> Display</button>
                </li>
            </ul>
            <ul className="widgetSmallList">
                <li className="widgetsmalllistItem">
                <img src = "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=465&q=80" alt = "hello"  className = "widget-profile-image" />
                    <div className="widgetSmalleruser">
                        <span className="widgetsmallerUsername">Anna Keller</span>
                        <span className="widgetsmallerUserjob">Software Engineer</span>
                    </div>
                    <button className="widgetsmallbtn"><VisibilityIcon className = "widgetSmallicon" /> Display</button>
                </li>
            </ul>
            <ul className="widgetSmallList">
                <li className="widgetsmalllistItem">
                <img src = "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=465&q=80" alt = "hello"  className = "widget-profile-image" />
                    <div className="widgetSmalleruser">
                        <span className="widgetsmallerUsername">Anna Keller</span>
                        <span className="widgetsmallerUserjob">Software Engineer</span>
                    </div>
                    <button className="widgetsmallbtn"><VisibilityIcon className = "widgetSmallicon" /> Display</button>
                </li>
            </ul>
        </div>
    )
}
